'use client';

import { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ProductCard from './ProductCard';
import ProductFilters from './ProductFilters';

const allProducts = [
  {
    id: 1,
    name: "Weight Management Capsules",
    category: "Weight Loss",
    price: 2199,
    originalPrice: 2858,
    rating: 4.8,
    reviews: 124,
    image: "/keto1.jpeg",
    benefits: ["Metabolism Boost", "Natural Fat Burn", "Appetite Control"],
    description: "Powerful blend of natural herbs to support healthy weight management and boost metabolism"
  },
  {
    id: 2,
    name: "Joint Pain Relief Oil",
    category: "Joint Pain",
   price: 1599,
    originalPrice: 2079,
    rating: 4.9,
    reviews: 89,
     image: "/joint1.jpeg",
    benefits: ["Reduces Pain", "Improves Mobility", "Natural Healing"],
    description: "Therapeutic oil blend with traditional herbs for effective joint pain relief and improved mobility."
  },
  {
    id: 3,
    name: "Weight Loss Tablets",
    category: "Weight Loss",
    price: 1999,
    originalPrice: 2599,
    rating: 4.7,
    reviews: 156,
    image: "/gain1.jpeg",
    benefits: ["Reduces Stress", "Improves Sleep", "Boosts Energy"],
    description: "Our herbal supplement is crafted with a powerful blend of Shuddha Guggul, Triphala, Trikatu, Trimad, and Vrikshamla. This unique Ayurvedic formulation helps support healthy weight management, digestion, and metabolism, while naturally boosting energy and overall wellness."
  },
  {
    id: 4,
    name: "Fit & Fine Slimming Oil",
    category: "Skin Care",
    price: 1599,
    originalPrice: 2079,
    rating: 4.9,
    reviews: 203,
    image: "/oil1.jpeg",
    benefits: ["Faster Results", "Stimulates Circulation", "Body Toning", "Tones Skin"],
    description: "Fit & Fine Slimming Oil is a 100% natural Ayurvedic formulation crafted with a blend of powerful herbal oils like Brahmi, Amla, Turmeric, Lemon, and Pomegranate. This oil is designed to help reduce cellulite, stimulate blood circulation, tone the skin, and promote a firmer body shape. Regular massage helps improve fat metabolism and supports inch loss naturally."
  },
  { 
    id: 5,
    name: "Weight Management Capsules Combo Pack",
    category: "Weight Loss",
    price: 2499,
    originalPrice: 3208,
    rating: 4.8,
    reviews: 124,
    image: "/c3.png",
    benefits: ["Metabolism Boost", "Natural Fat Burn", "Appetite Control"],
    description: "Powerful blend of natural herbs to support healthy weight management and boost metabolism",
  },
  
];

const categories = ["All", "Joint Pain", "Weight Loss", "Skin Care", "Weight Gain"];

export default function ProductsPage() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("featured");

  const filteredProducts = allProducts.filter(product => {
    const categoryMatch = selectedCategory === "All" || product.category === selectedCategory;
    return categoryMatch;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        return a.price - b.price;
      case "price-high":
        return b.price - a.price;
      case "rating":
        return b.rating - a.rating;
      case "reviews":
        return b.reviews - a.reviews;
      default:
        return 0;
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-6 sm:pt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Our Products</h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-600">
              Discover our complete range of authentic Ayurvedic products for holistic wellness
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-8">
            {/* Hide filters on mobile, show only on lg screens and up */}
            <div className="hidden lg:block">
              <ProductFilters
                categories={categories}
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
                sortBy={sortBy}
                onSortChange={setSortBy}
              />
            </div>

            <div className="flex-1">
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <p className="text-sm sm:text-base text-gray-600">
                  Showing {sortedProducts.length} of {allProducts.length} products
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
                {sortedProducts.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>

              {sortedProducts.length === 0 && (
                <div className="text-center py-16">
                  <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
                    <i className="ri-search-line text-gray-400 text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">No products found</h3>
                  <p className="text-gray-600">Try adjusting your filters to see more products</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}